// Detect ingredients mentioned in the recipe name that don't have QUID activated.
// Returns array of ingredient IDs that should probably have QUID = true.

const normalize = (s) =>
  (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // strip accents
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

// Trim simple French plurals (most common cases)
const trimPlural = (w) => {
  if (w.length <= 3) return w;
  if (w.endsWith("eaux")) return w.slice(0, -1); // poireaux -> poireau
  if (w.endsWith("ous")) return w.slice(0, -1);  // choux -> chou (close enough)
  if (w.endsWith("s")) return w.slice(0, -1);    // tomates -> tomate
  return w;
};

const STOPWORDS = new Set([
  "aux", "au", "de", "du", "la", "le", "les", "des", "et", "ou", "un", "une",
  "avec", "sans", "sur", "sous", "dans", "pour", "par", "thai", "thailandais",
  "rouge", "vert", "blanc", "noir", "frais", "fraiche", "froid", "chaud",
  "petit", "grand", "gros", "long", "court", "doux", "fort", "ancien",
  "nouveau", "mon", "ma", "mes", "ton", "ta", "son", "sa", "ses",
  "riz", "sauce",
]);

export const detectQuidCandidates = (recipeName, ingredients) => {
  if (!recipeName?.trim() || !Array.isArray(ingredients) || ingredients.length === 0) {
    return [];
  }
  const nameTokens = normalize(recipeName)
    .split(" ")
    .map(trimPlural)
    .filter((w) => w.length >= 4 && !STOPWORDS.has(w));

  if (nameTokens.length === 0) return [];

  const tokenSet = new Set(nameTokens);
  const candidates = [];

  for (const ing of ingredients) {
    if (ing.quid) continue; // already flagged
    const ingTokens = normalize(ing.name_fr || ing.description)
      .split(" ")
      .map(trimPlural)
      .filter((w) => w.length >= 4 && !STOPWORDS.has(w));

    const matched = ingTokens.find((t) => tokenSet.has(t));
    if (matched) {
      candidates.push({
        id: ing.id,
        label: ing.name_fr || ing.description,
        matched_word: matched,
      });
    }
  }
  return candidates;
};
